export const assetsURLs = {
  'gridTileMap': new URL('./grid_tile_map.png', import.meta.url).href,
  'starHemisphere': new URL('./star_hemisphere.glb', import.meta.url).href,
  'terrainSystems': new URL('./terrain_systems.glb', import.meta.url).href,
  'dice': new URL('./dice.glb', import.meta.url).href,

  'paladin': new URL('./Paladin.png', import.meta.url).href,
  icons: {
    deselect: new URL('./icons/deselect.png', import.meta.url).href,
    drawGrid: new URL('./icons/draw_grid.png', import.meta.url).href,
    move: new URL('./icons/move.png', import.meta.url).href,
    placeholderCube: new URL('./icons/placeholder_cube.png', import.meta.url).href,
    select: new URL('./icons/select.png', import.meta.url).href,
    door: new URL('./icons/door.png', import.meta.url).href,
    doorShut: new URL('./icons/door_shut.png', import.meta.url).href,
    eyeOpen: new URL('./icons/eye_open.png', import.meta.url).href,
    eyeShut: new URL('./icons/eye_shut.png', import.meta.url).href,
    simpleBook: new URL('./icons/simple_book.png', import.meta.url).href,

    wall: new URL('./icons/wall.png', import.meta.url).href,
    floor: new URL('./icons/floor.png', import.meta.url).href,
    trash: new URL('./icons/trash.png', import.meta.url).href,
    dice: new URL('./icons/dice.png', import.meta.url).href,
    mini: new URL('./icons/mini.png', import.meta.url).href,
    terrain_brush: new URL('./icons/terrain_brush.png', import.meta.url).href,
    selection: new URL('./icons/selection.png', import.meta.url).href,
    tools: new URL('./icons/tools.png', import.meta.url).href,
    bug: new URL('./icons/bug.png', import.meta.url).href,
    cleanup: new URL('./icons/cleanup.png', import.meta.url).href,
    surface: new URL('./icons/surface.png', import.meta.url).href,
    tickBlackCircle: new URL('./icons/tick_black_circle.png', import.meta.url).href,
  },
  cards: {
    simpleSkull: new URL('./cards/simple_skull.png', import.meta.url).href,
  },
  borders: {
    spikeBlack: new URL('./borders/spike_border_black.png', import.meta.url).href,
    spikeWhite: new URL('./borders/spike_border_white.png', import.meta.url).href,
    interiorBevel: new URL('./borders/nslice_interior_bevel.png', import.meta.url).href
  }
}